import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const BlogPage = () => {
  return (
    <div className="bg-cream pt-24" data-testid="blog-page">
      {/* Hero Section */}
      <section className="py-16 md:py-24 min-h-[70vh] flex items-center">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-3xl mx-auto"
          >
            <p className="text-terracotta font-body text-sm tracking-widest uppercase mb-4">
              Blog
            </p>
            <h1 className="font-heading text-5xl md:text-6xl text-forest leading-[1.1] mb-6">
              Grounded Thoughts<br />
              <span className="italic text-terracotta">Coming Soon</span>
            </h1>
            <p className="text-stone-600 text-lg font-body leading-relaxed mb-10">
              I'm working on creating content that reflects the same grounded, 
              back-to-basics approach I bring to my practice. Articles on movement, 
              nutrition, whole-self wellness, and the journey home to yourself.
            </p>
            
            {/* Newsletter Signup */}
            <div className="bg-stone-100 p-8 md:p-10 rounded-2xl max-w-xl mx-auto">
              <h3 className="font-heading text-2xl text-forest mb-4">
                Be the First to Know
              </h3>
              <p className="text-stone-600 font-body mb-6">
                Sign up for my newsletter and I'll let you know when new articles are published.
              </p>
              <form className="flex flex-col sm:flex-row gap-4" data-testid="blog-newsletter-form">
                <input
                  type="email"
                  placeholder="Your email address"
                  data-testid="blog-newsletter-email"
                  className="flex-1 bg-white border border-stone-300 rounded-full px-6 py-4 text-forest placeholder:text-stone-400 focus:outline-none focus:border-terracotta"
                />
                <button
                  type="submit"
                  data-testid="blog-newsletter-submit"
                  className="bg-forest text-cream px-8 py-4 rounded-full font-body font-medium hover:bg-forest-dark transition-all duration-300"
                >
                  Notify Me
                </button>
              </form>
            </div>

            <div className="mt-12">
              <Link
                to="/services"
                data-testid="blog-explore-services"
                className="inline-flex items-center gap-2 text-terracotta font-body font-medium hover:gap-4 transition-all duration-300"
              >
                Explore my services in the meantime
                <ArrowRight size={18} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
